import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";

export interface UrgentSourcingAnalyticsFilters {
  raised_by: FilterValue[] | null;
  status_updated_by: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface UrgentSourcingAnalyticsSelectedFilters {
  raised_by: FilterValue[] | null;
  status_updated_by: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface UrgentSourcingAnalyticsAPIFilters {
  raised_by: FilterValue[] | null;
  status_updated_by: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForUrgentSourcingAnalyticsFilters(
  params: UrgentSourcingAnalyticsFilters | null,
  query_params: URLSearchParams
): UrgentSourcingAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    raised_by: params?.raised_by ?? [],
    status_updated_by: params?.status_updated_by ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
